import { SERVER } from '../constants'

export const imagePath = (type, path) => `images/${type}/${path}`

export default (type, path) => {
  if (/^https?:/.test(path)) {
    return path;
  }
  return `${SERVER}/${imagePath(type, path)}`
}
